module.exports = __webpack_public_path__ + "static/media/mitsubishi-phone.e96df88c.svg";